<template>
    <div class="product-details">
        <packaging-swipper :article="article" />

        <div class="product-info">
            <h1 class="text-2xl font-weight-600 mb-4">{{ article.title }}</h1>
            <p class="mb-4">{{ article.summary }}</p>

            <table class="product-specs-table w-full mb-6 ">
                <tbody>
                    <tr v-for="(value, keyName) in articleAttr" :key="keyName" class="border-b border-gray-200">
                        <td class="py-2 font-weight-600 text-gray-600 w-1/3">{{keyName}} :</td>
                        <td class="py-2">{{value }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="product-actions mt-6 flex flex-between justify-between">
                <button class="btn-primary bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700">Get a Quote</button>
                <div class="contact-info mt-3 flex items-center ">
                    <span class="mr-2">Have a question?</span>
                    <nuxt-link href="/contact-us" class="contact-link text-green-600 hover:underline">Contact Us</nuxt-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts" name="PackagingFirstSection">
    import { computed } from 'vue'
    import type { Article } from '~/types'
    import packagingSwipper  from './packagingSwipper.vue'

    const props = defineProps<{
        article: Article
    }>()

    const parseArticleAttr = () => {
        let attr: any = props.article?.extAttr
        if (!attr) {
            return {}
        }

        if (typeof attr === 'string') {
            try {
                attr = JSON.parse(attr)
            } catch (error) {
                console.error('解析 extAttr 失败:', error)
                return {}
            }
        }

        if (!attr || typeof attr !== 'object') {
            return {}
        }

        const result: Record<string, any> = {}

        for (const key in attr) {
            if (Object.prototype.hasOwnProperty.call(attr, key)) {
                const value = attr[key]
                if (value && typeof value === 'object' && !Array.isArray(value)) {
                    Object.assign(result, value)
                } else {
                    result[key] = value
                }
            }
        }

        return result
    }

    const articleAttr = computed(() => parseArticleAttr())
</script>

<style scoped lang="scss">
    .product-details {
        display: flex;
        gap: 30px;

        @media (max-width: 768px) {
            flex-direction: column;
        }
    }

    .product-info {
        flex: 4;
        .product-specs-table {
            border-collapse: collapse;
            td {
                padding: 8px 0;
            }

            tr {
                border-bottom: 1px solid #eee;

                &:last-child {
                    border-bottom: none;
                }
            }
        }

        .product-actions {
            margin-top: 20px;

            .btn-primary {
                background-color: #4CAF50;
                color: white;
                border: none;
                padding: 12px 24px;
                font-weight: 600;
                cursor: pointer;

                &:hover {
                    background-color: #388e3c;
                }
            }

            .contact-info {
                margin-top: 10px;
                display: flex;
                align-items: center;

                .contact-link {
                    color: #4CAF50;
                    text-decoration: underline;
                    margin-left: 5px;
                }
            }
        }
    }
</style>
